import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';

import ListItem from './ListItem';
import CommentsListItem from './CommentsListItem';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './index.scss';

type Props = {
  onOpenToggle: Function;
  onPageChange: Function;
  setPage: Function;
  page: number;
};

export default function SearchResults({ onOpenToggle, onPageChange, setPage, page }: Props) {
  const { meetingItems, comments, itemsLength } = useSelector((state: any) => state.search);
  const { tr } = useTranslation();

  const { values } = useFormState();

  const handleClick = useCallback(() => {
    setPage(page + 1);
    onPageChange({ ...values, page: page + 1 });
  }, [onPageChange, page, setPage, values]);

  if (!itemsLength)
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-start h-100 w-100"
        style={{ paddingTop: '75px' }}
      >
        <p className="px-4 font-weight-light" style={{ fontSize: '24px', color: '#676D7D' }}>
          {tr('perform.search.results.no_results', values.searchStr)}
        </p>
      </div>
    );

  const inputItemsLength = meetingItems.length + comments.length;

  return (
    <div className="d-flex flex-column search-module-results rounded flex-column h-100 w-100">
      {meetingItems.map(actionItem => (
        <ListItem key={actionItem.id} onOpenToggle={onOpenToggle} item={actionItem} />
      ))}
      {comments.map(comment => (
        <CommentsListItem key={comment.id} onOpenToggle={onOpenToggle} item={comment} />
      ))}
      <div className="d-flex bg-white justify-content-between align-items-center px-4 pb-2 mt-2 rounded w-100">
        {inputItemsLength !== +itemsLength ? (
          <button className="btn text-primary shadow-none p-0" type="button" onClick={handleClick}>
            {tr('perform.search.results.load_more')}
          </button>
        ) : (
          <div />
        )}
        <p className="m-0">
          {tr('perform.search.results.showing_count', inputItemsLength.toString(), itemsLength.toString())}
        </p>
      </div>
    </div>
  );
}
